module.exports = __webpack_public_path__ + "static/media/cincoLogo1.81e33339.svg";